import { useTranslation } from "react-i18next";
import { Users, Bike, ChefHat } from "lucide-react";

export function TeamTabs({ activeTab, onTabChange }) {
  const { t } = useTranslation();

  const TABS = [
    { key: "gerentes",   label: t("team.tabManagers"), icon: Users },
    { key: "motorizados",label: t("team.tabRiders"),   icon: Bike },
    { key: "sirvientes", label: t("team.tabWaiters"),  icon: ChefHat },
  ];

  return (
    <div className="border-b border-gray-200">
      <div className="flex gap-6 overflow-x-auto">
        {TABS.map(tab => (
          <button
            key={tab.key}
            className={`pb-3 text-sm font-bold uppercase tracking-wide transition-colors border-b-2 flex items-center gap-2 whitespace-nowrap ${
              activeTab === tab.key
                ? "text-emerald-700 border-emerald-600"
                : "text-gray-500 border-transparent hover:text-gray-700"
            }`}
            onClick={() => onTabChange(tab.key)}
            data-testid={`tab-${tab.key}`}
          >
            <tab.icon className="w-4 h-4" /> {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
}
